exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".IconLink{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;position:relative;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.IconLink span{display:inline-block;position:relative;font-size:1.5rem;line-height:2rem;color:#fff;border-bottom:1px solid rgba(33,200,255,.5);margin-left:5px}.IconLink:hover span,.IconLink:active span{border-bottom-color:rgba(255,255,255,.5)}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/components/IconLink/IconLink.styl
// module id = 212
// module chunks = 0